import { timelineNodes } from '@/mocks/homeNews';
import SectionHeading from './SectionHeading';

const toneStyles: Record<string, { dot: string; ring: string; badge: string }> = {
  key: { dot: 'bg-primary-600', ring: 'border-primary-300', badge: 'bg-primary-100 text-primary-700' },
  warn: { dot: 'bg-accent-500', ring: 'border-accent-300', badge: 'bg-accent-100 text-accent-900' },
  neutral: {
    dot: 'bg-secondary-500',
    ring: 'border-secondary-300',
    badge: 'bg-secondary-100 text-secondary-900',
  },
};

export default function TrackingTimeline() {
  return (
    <section id="tracking" className="w-full bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <SectionHeading
          kicker="Tracking Timeline"
          title="爆料追踪时间线"
          desc="以「陆星辰录音风波」为主线，按时间顺序还原每一次回应、改口与商业动向，脉络一眼看清。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 rounded-lg border border-background-200 bg-background-100 p-5 md:p-8">
            <ol className="relative">
              <span className="absolute left-[7px] top-2 bottom-2 w-px bg-background-300" />
              {timelineNodes.map((node, idx) => {
                const tone = toneStyles[node.tone] ?? toneStyles.neutral;
                return (
                  <li key={`${node.date}-${idx}`} className="relative pl-8 pb-7 last:pb-0">
                    <span
                      className={`absolute left-0 top-1 w-[15px] h-[15px] rounded-full border-2 border-background-100 ${tone.dot}`}
                    />
                    <div className="flex flex-wrap items-center gap-3 mb-2">
                      <span className="text-[13px] font-semibold text-foreground-950">
                        {node.date}
                      </span>
                      <span className="text-[12px] text-foreground-500 tabular-nums">
                        {node.time}
                      </span>
                      <span className={`text-[11px] font-medium px-2 py-0.5 rounded-full ${tone.badge}`}>
                        {node.tone === 'key' ? '关键节点' : node.tone === 'warn' ? '出现反转' : '背景补充'}
                      </span>
                    </div>
                    <h3 className="text-[15px] md:text-[16px] font-semibold text-foreground-900 leading-snug">
                      {node.title}
                    </h3>
                    <p className="mt-1.5 text-[13px] leading-relaxed text-foreground-600">
                      {node.desc}
                    </p>
                  </li>
                );
              })}
            </ol>
          </div>

          <aside className="lg:col-span-4 flex flex-col gap-5">
            <div className="rounded-lg bg-foreground-950 p-5 md:p-6 text-background-50">
              <span className="text-[12px] tracking-widest text-accent-400 uppercase">Event Pulse</span>
              <h3 className="mt-2 font-heading text-[20px] font-bold">事件热度曲线</h3>
              <div className="mt-5 flex items-end gap-2 h-24">
                {[38, 62, 48, 84, 70, 100, 92].map((h, i) => (
                  <div key={i} className="flex-1 flex flex-col items-center gap-2">
                    <div
                      className={`w-full rounded-t-sm ${i === 5 ? 'bg-primary-500' : 'bg-background-700'}`}
                      style={{ height: `${h}%` }}
                    />
                  </div>
                ))}
              </div>
              <div className="mt-3 flex justify-between text-[11px] text-background-400">
                <span>09.07</span>
                <span>09.09</span>
                <span>09.12</span>
              </div>
              <div className="mt-5 pt-4 border-t border-background-800 flex items-center justify-between text-[12px]">
                <span className="text-background-300">当前热度</span>
                <span className="font-semibold text-accent-400">982 万 · 高位</span>
              </div>
            </div>

            <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-5 md:p-6">
              <div className="flex items-center gap-2 mb-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-information-line text-[15px] text-secondary-700" />
                </span>
                <span className="text-[13px] font-semibold text-secondary-900">阅读提示</span>
              </div>
              <p className="text-[13px] leading-relaxed text-secondary-900/80">
                以上内容均为网络公开信息的转载与时间线整理，各当事方回应以官方声明为准，请理性看待，不信谣不传谣。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}